import dayjs from 'dayjs';
import styles from './index.less';
import GeneralLayout from '../../../layouts/general';
import { useRouter } from 'next/router';
import React, { useMemo, useState, Fragment, useEffect, useCallback } from 'react';
import { getArticleByUrlTitle, fetchDataByLocale } from '../../../server-services/contentful';
import { CommonSectionLayout } from 'src/components/POSWebsite/legacy';
import { JoinClassName } from 'src/utils/utils';
import ContentfulRichText from '../ContentfulRichText';
import { CONTENTFUL_LOCAL_EN, CONTENTFUL_LOCAL_ZH } from 'src/utils/contentful';
import cookie from 'cookie';
import { FormattedMessage, useIntl } from 'react-intl';
import { Widget, PopupButton, Sidetab } from '@typeform/embed-react';
import { Grid } from 'antd';
import useLocale from 'src/hooks/useLocale';

const { useBreakpoint } = Grid;

const BlogArticlePage = ({ article: _article_, defualtLang }) => {
  const screens = useBreakpoint();
  const router = useRouter();
  let intl = useIntl();
  const locale = useLocale();
  const { article, typeformId, previewText } = useMemo(() => {
    let contentfulLocale = CONTENTFUL_LOCAL_EN;
    if (locale === 'en') {
      contentfulLocale = CONTENTFUL_LOCAL_EN;
    } else {
      contentfulLocale = CONTENTFUL_LOCAL_ZH;
    }
    let articleContent = _article_[contentfulLocale];
    let typeform_emailAddress = articleContent?.fields?.emailAddress || null;
    let typeformId = '';
    if (typeform_emailAddress) {
      let array = typeform_emailAddress.split('/');
      typeformId = array[array.length - 1];
    }

    const previewText = (articleContent.fields.previewText?.content || [])
      .map((content) => {
        return (content?.content || [])
          .map(({ value }) => {
            return value;
          })
          .join(' ');
      })
      .join(' ')
      .replace(/<[^>]+>/g, '');

    return {
      previewText,
      article: articleContent,
      typeformId,
      typeformEmailAddress: typeform_emailAddress,
    };
  }, [locale, _article_]);

  const updateTypeFormHeight = useCallback(
    (typeformHieght) => {
      // console.log('typeformRef::', document.querySelector('.' + styles.typeform));
      // const typeFormOuter = document.querySelector('.' + styles.typeform);
    },
    [screens.lg]
  );

  const featureImage = article?.fields?.featureImage || null;
  const typeform_emailAddress = article?.fields?.emailAddress || null;
  const pageFeaturedImage = featureImage?.fields.file.url || '';
  return (
    <GeneralLayout
      pageClass="blog-article-page full-width-page"
      pageTitle={article ? article.fields.title : 'POS Blogs | Chowbus POS'}
      metaDescription={previewText}
      pageFeaturedImage={pageFeaturedImage}
    >
      <div className={JoinClassName(styles.PageBlogArticle)}>
        <CommonSectionLayout backgroundColor="#ffffff" title={''} description={''}>
          <div className={JoinClassName(styles.backBlog)}>
            <a onClick={() => router.back()}> {`< ${intl.formatMessage({ id: 'home.blog.back' })} `}</a>
          </div>
          {article && (
            <React.Fragment>
              <h1 className={JoinClassName(styles.PageBlogArticleTitle)}>{article.fields.title}</h1>
              {article.fields?.publishTime && (
                <div className={JoinClassName(styles.PageBlogArticlePubishTime)}>
                  {dayjs(article.fields.publishTime).format('MMMM D, YYYY')}
                </div>
              )}
              {featureImage && (
                <img
                  src={featureImage.fields.file.url}
                  alt={featureImage.fields.title}
                  className={JoinClassName(styles.PageBlogArticleImage)}
                />
              )}
              {article.fields?.articleText && (
                <ContentfulRichText
                  document={article.fields.articleText}
                  contentfulLocale={locale == 'en' ? CONTENTFUL_LOCAL_EN : CONTENTFUL_LOCAL_ZH}
                />
              )}
            </React.Fragment>
          )}
          {typeform_emailAddress && typeformId && (
            <Fragment>
              <Widget
                id={typeformId}
                className={styles.typeform}
                // style={!screens.lg && typeformHeightRef.current ? { height: `${typeformHeightRef.current}px` } : {}}
                transitiveSearchParams={true}
                hideFooter={true}
                hideHeaders={true}
                autoResize={!screens.lg ? false : true}
                inlineOnMobile={true}
                disableScroll={true}
                onHeightChanged={(event) => {
                  updateTypeFormHeight(event.height);
                }}
              />
            </Fragment>
          )}
        </CommonSectionLayout>
      </div>
    </GeneralLayout>
  );
};

export async function getServerSideProps(context) {
  const { params, req, locale } = context;
  let resultData = null;
  const cookies = cookie.parse(req ? req.headers.cookie || '' : '');
  const defualtLang = cookies['pos.locale'] || 'en';
  try {
    resultData = await getArticleByUrlTitle(params.article);
    resultData = fetchDataByLocale(resultData);
  } catch (error) {
    console.log(error);
  }

  if (!resultData) {
    return {
      redirect: {
        destination: '/blog',
        permanent: true,
      },
    };
  }

  return {
    props: {
      article: resultData || null,
      defualtLang,
    },
  };
}

export default BlogArticlePage;
